import axios from 'axios';
import type { AnalyzeRequest, AnalyzeResponse, CreditsResponse, Analysis, PurchaseRequest, PurchaseResponse } from '../types';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

const api = axios.create({
  baseURL: `${API_URL}/api`,
  headers: {
    'Content-Type': 'application/json'
  }
});

export const analyzeVideo = async (data: AnalyzeRequest): Promise<AnalyzeResponse> => {
  const response = await api.post<AnalyzeResponse>('/analyze', data);
  return response.data;
};

export const getAnalysis = async (id: string): Promise<Analysis> => {
  const response = await api.get<Analysis>(`/analysis/${id}`);
  return response.data;
};

export const getHistory = async (): Promise<Analysis[]> => {
  const response = await api.get<Analysis[]>('/history');
  return response.data;
};

export const getCredits = async (): Promise<CreditsResponse> => {
  const response = await api.get<CreditsResponse>('/user/credits');
  return response.data;
};

export const purchaseCredits = async (data: PurchaseRequest): Promise<PurchaseResponse> => {
  const response = await api.post<PurchaseResponse>('/credits/purchase', data);
  return response.data;
};

export default api;

